/**
* Copyright Aquera Inc 2023
*
* This source code is licensed under the BSD-3-Clause license found in the
* LICENSE file in the root directory of this source tree.
*/

import {css} from 'lit';

/**
 * SideBarHeader CSS
 */
export const styles = css`
 :host {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: var(--nile-spacing-xl, var(--ng-spacing-3xl));
  padding-bottom: var(--nile-spacing-lg, var(--ng-spacing-xl));
  padding-left: var(--nile-spacing-xl, var(--ng-spacing-2xl));
  padding-right: var(--nile-spacing-xl, var(--ng-spacing-2xl));
  top: 0;
  background: var(--nile-colors-neutral-100, var(--ng-colors-bg-primary));
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}


:host([collapsed]) .header-content {
  flex-direction: column;
  justify-content: center;
  gap: var(--nile-spacing-lg, var(--ng-spacing-md));
}



 
 
::slotted([slot='logo']) {
  font-size: var(--nile-type-scale-3, var(--ng-font-size-text-sm));
  font-weight: var(--nile-font-weight-bold, var(--ng-font-weight-bold));
  letter-spacing: -0.02em;
  color: var(--nile-colors-dark-900, var(--ng-colors-graylightmode-900));
  text-transform: none;
}

::slotted([slot='actions']) {
  display: flex;
  align-items: center;
  gap: var(--nile-spacing-md);
}

`;

export default [styles];